import { AlertCircle, CheckCircle2, Info } from 'lucide-react'
import { useStaat, zet } from '../lib/staat'

/** Korte meldingen rechtsonder. Een fout blijft langer staan; klik = weg. */
export default function Meldingen() {
  const meldingen = useStaat((s) => s.meldingen)
  if (!meldingen.length) return null
  return (
    <div className="meldingen" role="status" aria-live="polite">
      {meldingen.map((m) => (
        <button key={m.id} type="button" className={`toast ${m.soort}`}
          onClick={() => zet({ meldingen: meldingen.filter((x) => x.id !== m.id) })}>
          {m.soort === 'fout' ? <AlertCircle size={16} /> : m.soort === 'ok' ? <CheckCircle2 size={16} /> : <Info size={16} />}
          <span>{m.tekst}</span>
        </button>
      ))}
    </div>
  )
}
